import { Button } from "@chakra-ui/react";
import { MinusIcon, PlusIcon } from "@/components/icons";

type Props = {
  onClick?: () => void;
  type: "add" | "remove";
  isDisabled?: boolean;
};

export function AddRemoveButton(props: Props) {
  return (
    <>
      {props.type === "add" ? (
        <Button
          size="xs"
          color="blue.500"
          _hover={{ bg: "blue.500", color: "white" }}
          onClick={props.onClick}
          isDisabled={props.isDisabled}
        >
          <PlusIcon />
        </Button>
      ) : (
        <Button
          size="xs"
          color="red.500"
          _hover={{ bg: "red.500", color: "white" }}
          onClick={props.onClick}
          isDisabled={props.isDisabled}
        >
          <MinusIcon />
        </Button>
      )}
    </>
  );
}
